<template>
  <div @scroll="onScroll" ref="infiniteScrollWrap">
    <slot></slot>
    <slot name="loading">
      <span>Loading...</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: "InfiniteScroll",
  methods: {
    loadMore() {
      this.$emit("next");
    },
    onScroll() {
      const { infiniteScrollWrap } = this.$refs;
      if (
        infiniteScrollWrap.scrollTop + infiniteScrollWrap.clientHeight >=
        infiniteScrollWrap.scrollHeight
      ) {
        this.loadMore();
      }
    },
  },
};
</script>
